type Context = 'integration';

type IntegrationType = 'jobAdder';

type Section =
  | 'owner-mappings'
  | 'owners'
  | 'fbl-fields'
  | 'fields'
  | 'custom-fields'
  | 'standard-fields'
  | 'field-mappings'
  | 'settings';

type Value = `${Context}-${IntegrationType}-${Section}`;

export const Keys: Record<Section, Value> = {
  'owner-mappings': 'integration-jobAdder-owner-mappings',
  owners: 'integration-jobAdder-owners',
  'fbl-fields': 'integration-jobAdder-fbl-fields',
  fields: 'integration-jobAdder-fields',
  'custom-fields': 'integration-jobAdder-custom-fields',
  'standard-fields': 'integration-jobAdder-standard-fields',
  'field-mappings': 'integration-jobAdder-field-mappings',
  settings: 'integration-jobAdder-settings',
};
